import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-success-or-warning-popup',
    imports: [CommonModule],
    templateUrl: './success-or-warning-popup.component.html',
    styleUrl: './success-or-warning-popup.component.css'
})
export class SuccessOrWarningPopupComponent implements OnInit {
  @Input() popupType: string = ''; // warning or success
  @Input() displayText: string = '';
  @Input() fromPage: string = '';
  @Output() message = new EventEmitter<string>();

  ngOnInit(): void {
    document.getElementById(this.popupType)?.scrollIntoView();
  }

  sendMessage() {
    this.displayText = '';
    this.message.emit();
  }
}
